import angular from 'angular'
import ngAnimate from "angular-animate"
import ngAria from "angular-aria"
import ngMessages from "angular-messages"
import ngSanitize from "angular-sanitize"

import { CoreModule } from '../core/core.module'
import { ComponentsModule } from './components/components.module'
import { DirectivesModule } from './directives/directives.module'
import { CapitalizeFilter, JoinFilter, LocaleTranslateFilter, PaginateFilter, PropsFilter, StartFromFilter, TableColumnFilter, PermissionGrantFilter } from './filters'

/** A module containing common generic templating and logic components */
export const CommonModule = angular
    .module("apex.common", [
        // Common vendor libraries
        ngAnimate,
        ngAria,
        ngMessages,
        ngSanitize,
        "angularMoment", // Required from vendor listings
        // Extend the winxnet core (built within MVC project)
        "winxnet", // Required from vendor file
        ComponentsModule,
        CoreModule,
        DirectivesModule
    ])
    // Note: filters are functions that angular instantiates with new,
    // so they have a `this` context.
    .filter("capitalize", CapitalizeFilter)
    .filter("join", JoinFilter)
    .filter("translate", LocaleTranslateFilter)
    .filter("paginate", PaginateFilter)
    .filter("permission", PermissionGrantFilter)
    .filter("propsFilter", PropsFilter)
    .filter("startFrom", StartFromFilter)
    .filter('mdTableColumnarFilter', TableColumnFilter)
    .name
